import axios from 'axios';
import errorHandler from './errorHandler';
import setAuthorizationHeaders from './setAuthorizationHeaders';
import { store } from '../../store';
/* =========================
   REQUEST QUEUE (GLOBAL)
========================= */
let queue = Promise.resolve();

const enqueue = (request) => {
  queue = queue.then(() => request()).catch(() => request()); // lanjut walaupun gagal
  return queue;
};

/* =========================
   AXIOS INSTANCE
========================= */

// const baseURL = import.meta.env.VITE_API_GATEWAY;
const baseURL = window?.location?.hostname?.includes('localhosts') ? import.meta.env.VITE_API_GATEWAY : window?.location?.origin + '/api/';

const instance = axios.create({
  baseURL,
  withCredentials: true
});

/* =========================
   REQUEST INTERCEPTOR
========================= */
instance.interceptors.request.use((config) => {
  const state = store.getState();
  const accessToken = state.reduxState?.accessToken;
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  // 🔥 inject queue
  config._queuedRequest = () => axios(config);
  return config;
});

/* =========================
   RESPONSE INTERCEPTOR
========================= */
instance.interceptors.response.use((response) => response.data, errorHandler);

export { setAuthorizationHeaders };
export default instance;
